import React, { useState, useEffect } from 'react';
import styles from './CaptureNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import CaptureModal from './capture-modal/CaptureModal';
import { variableManagement, workflow } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';

const CaptureNode = ({ id, data, selected, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [label, setLabel] = useState(null);
  const [isError, setIsError] = useState(node?.is_Error || false);

  const { data: apiData, isFetching } = useFetch(
    ['variableManagement'],
    variableManagement.get,
    { enabled: true },
    { pageSize: 1000, pageNumber: 1 }
  );

  const variableTypes = [
    { label: 'Text', value: 0 },
    { label: 'Voice', value: 1 },
    { label: 'Text/Voice', value: 2 },
  ];

  useEffect(() => {
    if (apiData?.data?.items && node?.capture?.variableId) {
      const foundVariable = apiData.data.items.find(
        (val) => val.variableId === node.capture.variableId
      );
      setLabel(foundVariable?.variableName || null);
    }
  }, [apiData, node?.capture?.variableId]);

  useEffect(() => {
    if (node?.capture !== undefined) {
      if (label === null) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.capture, label]);

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Capture Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />
        <div className={styles.cont}>
          {node?.capture == undefined || !node?.capture?.variableId ? (
            <div className={styles.details}>
              <SvgWithBranding type='node-capture' color='#787878' />
              <p className={styles.placeholder}>Select Entity to Capture</p>
            </div>
          ) : (
            <>
              <div className={styles.details}>
                <SvgWithBranding type='node-capture' color='#787878' />
                <p>Save Entire Reply to:</p>
              </div>
              {label && <p className={styles.type}>{label}</p>}
            </>
          )}
        </div>
        <Handle
          type='source'
          position={Position.Right}
          className='custom-handle'
        />
      </NodeContainer>
      <CaptureModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Capture'
        id={id}
        data={apiData}
        isFetching={isFetching}
        isError={isError}
      />
    </>
  );
};

export default CaptureNode;
